import { h } from "omi";

export function StarGraphic() {
  return (
    <svg width="85" height="84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.1048 28.6773c-2.3-1.9-4.6001-3.8-6.8001-5.8-1.5-1.4-2.9-2.8-4.3-4.2-13.9-13.6-5.6 14.6-8.2 18.7-3.7 6-11.0999 4.9-16.4999 7.9-.6.3-1.0001.7-1.2001 1.5-1.6 6.4 15.6 2.3 19.6 7.6 3.1 4.1.3 17.6 6.3 19.3 6.3 1.9 7.5001-15.4 10.4001-17.8 4.8-4.1 14.7999 1.1 19.8999 2.4.3.1 1.5001.5 1.8001.1 4-5.6-6.4001-14.8-8.3001-19.4-2.7-6.4 4.8-11.6 3-17.6-2.8-9.1-14.5999 2.5-15.6999 7.1M11.9 26.1C8.6 25.4 5.3 24.8 2 24M18.3 18c-2.4-1.2-4.8-2.2-7.3-3M13.9 62c-1 .6-1.9 1.2-2.9 1.8M18.6 70C17 72.8 15 75.3 13 77.8M50 80c.2.8.1.6.4 2M59 72c1.8 3.1 3.7 6.4 6.1 9.1M75 48c3 1 5.9 2.1 8.9 3.1M83.7 39c-1.6-.3-3.1-.7-4.7-1M52 12.3c2.4-3.1 5.2-5.7 8.1-8.3M44 5.8c1.1-1.3 2.3-2.6 3.5-3.8"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
